





















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

import constants      from '@/constants';

import SiteReference from '@/models/SiteReference';

import api from '@/api/api';

/** How long to wait after the *last* keystroke before firing the XHR to get results */
const DEBOUNCE_TIMER = 150;

/** How many suggestions show in autocomplete  */
const NUM_AUTOCOMPLETE_SUGGESTIONS = 5;

@Component({
  name: 'AutoCompleteDesktop'
})

/**
 * Autocomplete is open when
 *
 * - input has state
 * - autocomplete has focus
 * - menu wasn't closed with escape
 *
 * Autocomplete clears state when
 * - search results tray button is clicked
 * --> this means that active search term should be a vuex property, goddammit
 * --> but so should back and that probably helps us here
 */
export default class AutoComplete extends Vue {

  //
  // data properties
  //
  activeSuggestionIndex = -1;

  allSuggestions = new Array<SiteReference>();

  // FIXME: this name is shitty
  suggestionBoxWasClosed = false;

  // NEW MENU OPEN-NESS CONTROLLER LOGIC
  //
  // (THAT'S IT, ALL THAT'S NEEDED + DEBOUNCEDINPUT, AND A CLEARINPUT() METHOD)
  hasFocus = false;
  userClosed = false;

  inputValueModel = '';

  /** Debounced keyboard input - IMPORTANT, watcher fires when this changes */
  debouncedInput = '';
  debounceTimeout: number = -1;

  /** The last input string that was queried - IMPORTANT used to prevent out of order xhrs */
  lastQueriedInput = '';

  isQuerying = false;


  @Prop({ required: true, default: false }) readonly hasStateContext!: boolean;
  @Prop({ required: false, default: '' }) readonly stateContextTitle!: string;

  @Prop({ required: true, default: false }) readonly hasBackRoute!: boolean;
  @Prop({ required: false, default: '' }) readonly backRoute!: string;

  //
  // computed properties
  //

  /** The first n suggestions that show up in the autocomplete menu */
  get autocompleteSuggestions() {
    return this.allSuggestions.slice(0, NUM_AUTOCOMPLETE_SUGGESTIONS);
  }

  get isSuggestionBoxOpen() {

    // there's text in the input
    return  (this.debouncedInput !== '')

          // the input element is focused
          && this.hasFocus

          // user didn't close box w/ escape OR user did close box w/ escape but then typed more input
          &&  !this.userClosed

          // AND there are suggestions!
          && this.allSuggestions.length;
  }

  get numSuggestions () {
    return this.allSuggestions.length;
  }

  get isBackButtonPresent() {
    return this.hasBackRoute;
  }

  get isCloseButtonPresent() {
    return this.hasStateContext;
  }

  //
  // watchers
  //
  @Watch('autocompleteSuggestions')
  onAutocompleteSuggestionsChanged(nextSuggestions: Array<any>, oldSuggestions: Array<any>) {
    if (nextSuggestions.length > 0) {
      // Anytime the suggestion box is open, force the tray to be open
      if (oldSuggestions.length === 0) {
        this.$store.dispatch('setIsTrayOpen', true);
      }
    }
  }

  /**
   * When *debounced* input changes, query for search results
   */
  @Watch('debouncedInput')
  async onDebouncedInputChanged(input: string, oldInput: string) {
    this.lastQueriedInput = input;
    let suggestions: Array<SiteReference> = [];
    this.isQuerying = true;

    // Only query when keyboard input is present
    if (this.lastQueriedInput.length > 0) {
      suggestions = await api.getSitesWithKeyword(input);

      // IMPORTANT: This is how we deal with out of order XHR returns!
      //
      // Only show the search results if the search string from this query still matches what's in the input
      if (input === this.lastQueriedInput) {
        this.allSuggestions = suggestions;
        this.isQuerying = false;
      }
    }
    return suggestions;
  }

  private setStateContextTitleInInputModel(nextStateContextTitle: string) {
    this.inputValueModel = nextStateContextTitle;
  }

  //
  // watchers
  //

  /**
   * Update the input field with the site name or search terms *when* state context changes (e.g. user navigates to a detail page or does a search)
   */
  @Watch('stateContextTitle')
  onStateContextTitleChanged(nextStateContextTitle: string, oldStateContextTitle: string): void {
    if (this.hasStateContext) {
      this.setStateContextTitleInInputModel(nextStateContextTitle);
    }
  }

  //
  // methods
  //

  handleInput (event: InputEvent) {

    // Debounce that shit...
    //
    // but manually - originally I tried to use a library but that doesn't play well at all
    // with updating state in Vue getters, watchers, etc, and it's not hard.
    const currentTextInput = event && event.currentTarget && (<HTMLInputElement>event.currentTarget).value;
    if (currentTextInput || currentTextInput === "") {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }
      this.debounceTimeout = setTimeout(() => {
        this.debouncedInput = currentTextInput
      }, DEBOUNCE_TIMER);
    }
  }

  async handleKeyDown(event: KeyboardEvent) {

    switch(event.key) {

      case 'Enter':
        this.suggestionBoxWasClosed = true;

        // TODO: explain wtf is going on here
        const menuItemIsActive = this.$data.activeSuggestionIndex >= 0;
        if (menuItemIsActive) {
          // Nothing to be done here... we've already changed the route just from the menu item being active
        } else {
          this.handleShowAllResults();
        }

        this.clearInput()
        this.setUserClosed(true);
        this.triggerAutocompleteBlur();
        break;

      case 'Escape':

        this.setUserClosed(true);
        break;

      case 'ArrowDown':
      case 'ArrowRight':
        this.setUserClosed(false);

        if (this.isSuggestionBoxOpen) {
          ++this.activeSuggestionIndex;
          if (this.activeSuggestionIndex === this.autocompleteSuggestions.length) {
            this.activeSuggestionIndex = -1;
          } else {
            await this.navigateToSiteRoute(this.autocompleteSuggestions[this.activeSuggestionIndex], true);
          }
        }
        else if (this.autocompleteSuggestions.length > 0) {
          this.userClosed = false;
        }

        event.preventDefault();
        break;

      case 'ArrowUp':
      case 'ArrowLeft':
        this.setUserClosed(false);

        if (this.isSuggestionBoxOpen) {
          --this.activeSuggestionIndex;
          if (this.activeSuggestionIndex === -1) {
            this.activeSuggestionIndex = this.autocompleteSuggestions.length;
          } else {
            await this.navigateToSiteRoute(this.autocompleteSuggestions[this.activeSuggestionIndex], true);
          }
        }
        else if (this.autocompleteSuggestions.length > 0) {
          this.userClosed = false;
        }

        event.preventDefault();
        break;
      default:
        this.setUserClosed(false);
    }
  }

  handleMenuItemClick(menuItem: any) {
    this.suggestionBoxWasClosed = true;
    this.clearInput();

    // const siteNumber = args.siteNumber;
    this.navigateToSiteRoute(menuItem, false);
    this.userClosed = true;

    this.triggerAutocompleteBlur();
  }

  //  TODO ARCHITECTURE: use Vue composition API for this (duplicate code w/ Map)
  async handleGeolocate() {
    try {
      // TODO TYPE SAFETY - Figure out how to stub this
      const coordinates = await (this as any).$getLocation()

      const lat = coordinates.lat.toFixed(4);
      const lng = coordinates.lng.toFixed(4);

      this.$router.push({ name: constants.RouteNames.NearLocation, query: { lat, lng } });

    } catch(e) {
      this.$emit('geolocationerror');
    }

    this.triggerAutocompleteBlur();
  }

  handleShowAllResults() {
    const terms = (this.$refs.input as HTMLInputElement).value;
    this.setUserClosed(true);
    this.navigateToSearchRoute(terms);
  }

  handleBackButton() {
    // Clear input
    this.inputValueModel = '';

    // Navigate back
    this.$router.push(this.backRoute);
  }

  async handleCloseButton() {

    // Navigate to Main
    await this.$router.push({name: constants.RouteNames.Main});

    // Clear active site reference
    //
    // HMMM... shouldn't this only be needed ifSiteRoute? maybe it doesn't matter.
    await this.$store.dispatch('clearSiteReference')

    this.inputValueModel = '';

    (this.$refs.input as HTMLInputElement).focus();

  }

  async navigateToSearchRoute(terms: string) {
    await this.$router.push({name: constants.RouteNames.Search, params: {
      query: terms
    }});

    this.triggerAutocompleteBlur();
  }

  async navigateToSiteRoute(site: any, leaveSuggestionBoxOpen: boolean) {
    if (!leaveSuggestionBoxOpen) {

      // FIXME: 508 bug here, someone needs the focus!
      this.setHasFocus(true);
      // this.closeSuggestionBox();
      this.reset();
    }

    await this.$router.push({name: constants.RouteNames.MiniDetail, params: {
      siteNumber: site.siteNumber,
      state: site.state.toLowerCase(),
      siteReference: site
    }});
  }

  setHasFocus(hasFocus: boolean) {
    this.hasFocus = hasFocus;
    this.$store.dispatch('setAutocompleteHasFocus', this.hasFocus)
  }

  reset() {
    this.setUserClosed(false);
    this.clearInput();
  }

  setUserClosed(userClosed: boolean) {
    this.userClosed = userClosed;
  }

  handleAutocompleteBlur() {
    this.setHasFocus(false);
  }

  handleFocus() {
    this.setHasFocus(true);

    // Force open tray
    this.$store.dispatch('setIsTrayOpen', true);
  }

  triggerAutocompleteBlur() {
    (this.$refs.input as HTMLInputElement).blur();
  }

  clearInput() {
    (this.$refs.input as HTMLInputElement).value = '';
  }

}
